import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';
import { pageHeaderIntroStyle } from '../shared.styles';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useSectionHeaderStyles = makeStyles(() => ({
  sectionIntro: {
    ...pageHeaderIntroStyle,
  },
  tag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing.xs,
    alignSelf: 'flex-start',
    padding: spacing.xs,
    borderRadius: radius.sm,
    backgroundColor: colors.accentMuted,
    color: colors.brownLight,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    lineHeight: 'normal',
  },
  tagDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: colors.brownLight,
  },
  sectionTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.intro,
    color: colors.primaryDark,
    lineHeight: 'normal',
  },
  sectionDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.brownDark,
    lineHeight: 'normal',
  },
  sectionDescriptionBrown: {
    color: colors.brown,
  },
}));
